/*
 * @Author: Josselin Hubert
 * @Date: 2020-09-01 22:40:10
 * @Last Modified by: Josselin Hubert
 * @Last Modified time: 2020-09-02 15:59:52
 */


<template>
  <section id="hero">
    <!-- :src="require('@/assets/simple-header-blended-small.png')" -->
    <!-- gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)" -->
    <base-jumbotron :src="require('@/assets/AdobeStock.png')"
                    class="white--text"
                    contain
                    gradient="to right, rgba(5, 11, 31, 0.5), rgba(5, 11, 31, 0.1)"
                    height="110vh">
      <v-row align="center"
             class="pb-12 white--text">
        <v-col cols="12"
               md="8">
          <div>
            <base-title>
              {{$t('appName')}}
            </base-title>

            <v-divider class="mb-3" />

            <div class="subheading mb-4">
              <p>{{$t('panel.home.subtitle1')}}</p>

              <p>
                {{$t('panel.home.subtitle2')}}
              </p>
            </div>

            <v-btn color="white"
                   class="mt-5"
                   @click="$vuetify.goTo('#talk', options)"
                   large>
              {{$t('button.knowMore')}}
              <v-icon right>
                mdi-school
              </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </base-jumbotron>
  </section>
</template>

<script>
  export default {
    name: "HomeHero",

    computed: {
      options() {
        return {
          duration: 500,
          easing: "easeInOutCubic",
          offset: 50,
        };
      },
    },
  };
</script>
